/**
 * Gets the authentication route for partner and region.
 * @returns string value.
 */
/* istanbul ignore next: No need to codecov */
export function getPartnerAuthenticationRoute(currentPartner: string, currentPartnerRegion: string): string {
  const redirectRoute = `/${currentPartner}/${currentPartnerRegion}/`;
  return redirectRoute;
}
